import { render, staticRenderFns } from "./GLBgIcon.vue?vue&type=template&id=c6810e50&scoped=true"
import script from "./GLBgIcon.vue?vue&type=script&lang=js"
export * from "./GLBgIcon.vue?vue&type=script&lang=js"
import style0 from "./GLBgIcon.vue?vue&type=style&index=0&id=c6810e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6810e50",
  null
  
)

export default component.exports